import { Button } from '@mui/material'
import React from 'react'
import './SecondaryButton.css'

const SecondaryButton = (props) => {
    const { label, onClick, type = 'button', width = '100%', height = '56px', marginTop = '10px', className, startIcon, border, opacity, sx, disableGrayEffect, disableRipple = false, disabled } = props
    const handleClick = typeof onClick === 'function' ? onClick : () => { }

    return (
        <Button
            onClick={handleClick}
            startIcon={startIcon}
            type={type}
            className={`secondaryButton-SecondaryButton ${className}`}
            disableRipple={disableRipple}
            disabled={disabled}
            style={{
                width: width,
                height: height,
                marginTop: marginTop,
                border: border,
                opacity: opacity,
                ...sx,
                ...(disableGrayEffect && {
                    '&.Mui-disabled': {
                        opacity: opacity ?? 1,
                        cursor: 'not-allowed',
                    }
                })
            }}
        >
            {label}
        </Button>
    )
}

export default SecondaryButton

